import React from 'react'
import { motion } from 'framer-motion'
import { Moon, Sun, Monitor } from 'lucide-react'
import { useTheme } from '../contexts/ThemeContext'
import { cn } from '../lib/utils'

export function ThemeIndicator() {
  const { theme, resolvedTheme } = useTheme()

  const getThemeInfo = () => {
    switch (theme) {
      case 'system':
        return {
          icon: Monitor,
          label: 'System',
          description: resolvedTheme === 'dark' ? 'Dark' : 'Light'
        }
      case 'light':
        return {
          icon: Sun,
          label: 'Light',
          description: 'Theme'
        }
      case 'dark':
        return {
          icon: Moon,
          label: 'Dark',
          description: 'Theme'
        }
      default:
        return {
          icon: Monitor,
          label: 'System',
          description: 'Theme'
        }
    }
  }

  const themeInfo = getThemeInfo()
  const Icon = themeInfo.icon

  return (
    <motion.div
      className={cn(
        "flex items-center space-x-2 px-3 py-1.5 rounded-lg text-xs font-medium",
        "bg-muted/50 border border-border/30",
        resolvedTheme === 'dark' ? "text-muted-foreground" : "text-gray-600"
      )}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2 }}
    >
      <Icon className="h-3 w-3" />
      <span>{themeInfo.label}</span>
      {theme === 'system' && (
        <span className="text-xs opacity-70">({themeInfo.description})</span>
      )}
    </motion.div>
  )
} 